<template>
  <div class="modal-content fm-modal-audio-player">
    <div class="modal-header">
      <h5 class="modal-title">
        {{ lang.modal.audioPlayer.title }}
      </h5>
      <button type="button" class="close" aria-label="Close" @click="hideModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <audio
        class="fm-audio"
        controls
        :src="`${storagePrefix}/${audioFile.path}`"
      />
      <!--<hr />
      <div
        v-for="(item, index) in audioFiles"
        :key="index"
        class="d-flex justify-content-between py-2 px-2"
        :class="playingIndex === index ? 'bg-light' : ''"
      >
        <div class="w-75 text-truncate">
          <span class="text-muted pr-2">{{ index }}.</span>
          {{ item.basename }}
        </div>
        <template v-if="playingIndex === index">
          <div v-if="status === 'playing'">
            <i class="fas fa-play active" @click="togglePlay()" />
          </div>
          <div v-else>
            <i class="fas fa-pause" @click="togglePlay()" />
          </div>
        </template>
        <template v-else>
          <div>
            <i class="fas fa-play" @click="selectTrack(index)" />
          </div>
        </template>
      </div>-->
    </div>
  </div>
</template>

<script>
import modal from "../mixins/modal";
import translate from "../../../mixins/translate";

export default {
  name: "Player",
  mixins: [modal, translate],
  computed: {
    /**
     * Audio file
     * @returns {*}
     */
    audioFile() {
      return this.$store.getters["fm/selectedItems"][0];
    },
    storagePrefix() {
      return this.$store.getters.getStoragePrefix;
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {}
};
</script>

<style lang="scss">
.fm-audio {
  width: 100%;
  max-width: 100%;
}
</style>
